import { render, staticRenderFns } from "./nice-label.vue?vue&type=template&id=6d844b16&scoped=true"
import script from "./nice-label.vue?vue&type=script&lang=js"
export * from "./nice-label.vue?vue&type=script&lang=js"
import style0 from "./nice-label.vue?vue&type=style&index=0&id=6d844b16&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d844b16",
  null
  
)

export default component.exports